import { render, staticRenderFns } from "./EditOrderExpectedShipDate.vue?vue&type=template&id=2d97e9c3&"
import script from "./EditOrderExpectedShipDate.vue?vue&type=script&lang=js&"
export * from "./EditOrderExpectedShipDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports